import { Stack } from '@mui/system';
import { Note } from 'modules/service-call/types';
import React, { useMemo } from 'react';
import { ServiceCallNote } from './ServiceCallNote';
import { ServiceCallNoteReplyAccordion } from './ServiceCallNoteReplyAccordion';
import sortBy from 'lodash/sortBy';

interface ServiceCallNotesSectionProps {
  notes: Note[],
  serviceCallId: string
}

export const ServiceCallNotesSection: React.FC<ServiceCallNotesSectionProps> = ({ notes, serviceCallId }) => {

  const displayedNotes = useMemo(() => {
    return sortBy(notes, note => note.createdOn).reverse();
  }, [notes]);

  return (
    <Stack gap={2}>
      <ServiceCallNoteReplyAccordion serviceCallId={serviceCallId} />
      <Stack gap={2}>
        {displayedNotes.map(note => <ServiceCallNote key={note.id} note={note} serviceCallId={serviceCallId} />)}
      </Stack>
    </Stack>
  );
};